import { useCallback } from "react";
import { Menu, MenuItem } from "@snpjs/core";
import { CompactMultiSelect, ItemListRendererProps } from "@snpjs/select";

import { TableFilterProps } from "./TableFilter.types";

export const MultiSelectFilterComponent: React.FC<TableFilterProps> = ({ value, options = [], onChange }) => {
  const selectedValues = Array.isArray(value) ? value as string[] : [];
  const areAllSelected = options.length > 0 && options.every((option) => selectedValues.includes(option));
  const toggleItem = useCallback((item: string) => {
    const nextValues = selectedValues.includes(item)
      ? selectedValues.filter((selected) => selected !== item)
      : [...selectedValues, item];
    onChange(nextValues.length > 0 ? nextValues : undefined);
  }, [onChange, selectedValues]);
  const removeItem = useCallback((item: string) => {
    const nextValues = selectedValues.filter((selected) => selected !== item);
    onChange(nextValues.length > 0 ? nextValues : undefined);
  }, [onChange, selectedValues]);
  const matchesQuery = useCallback((query: string, item: string) =>
    item.toLowerCase().includes(query.trim().toLowerCase()), []);

  const renderItem = useCallback((item: string, itemProps: Parameters<NonNullable<React.ComponentProps<typeof CompactMultiSelect<string>>["itemRenderer"]>>[1]) => (
    <MenuItem
      active={itemProps.modifiers.active}
      disabled={itemProps.modifiers.disabled}
    //   icon={selectedValues.includes(item) ? "tick" : undefined}
      key={item}
      onClick={itemProps.handleClick}
      onFocus={itemProps.handleFocus}
      ref={itemProps.ref}
      roleStructure="listoption"
      text={item}
    />
  ), []);

  const renderItemList = useCallback(({ filteredItems, itemsParentRef, menuProps, renderItem }: ItemListRendererProps<string>) => (
    <Menu {...menuProps} ulRef={itemsParentRef}>
      <MenuItem
        text={areAllSelected ? "Deselect All" : "Select All"}
        roleStructure="listoption"
        shouldDismissPopover={false}
        onClick={() => onChange(areAllSelected ? undefined : options)}
      />
      {filteredItems.map((item, index) => renderItem(item, index))}
    </Menu>
  ), [areAllSelected, onChange, options]);

  return (
    <CompactMultiSelect<string>
      fill
      items={options}
      itemPredicate={matchesQuery}
      itemRenderer={renderItem}
      itemListRenderer={renderItemList}
      onClear={() => onChange(undefined)}
      onItemSelect={toggleItem}
      onRemove={removeItem}
      placeholder="Type..."
      selectedItems={selectedValues}
      tagRenderer={(item) => item}
    />
  );
};